//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    label: {
      type: String,
      default: () => '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    minCharacterSearch: {
      type: Number,
      default: () => 2,
    },
    clearOnSelect: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    name: '',
    isActive: false,
  }),
  methods: {
    handleSelect(selected) {
      this.$emit('selected', selected)
    },
    handleTyping(value) {
      if (value.length >= this.minCharacterSearch) {
        this.isActive = true
        this.$emit('typing', value)
      } else {
        this.$emit('cleaning', value)
        this.isActive = false
      }
    },
  },
}
